import React from 'react';

export const TermsTemplate = () => (
  <>
    <h3>Terms of Use</h3>
    <p>
      Please read these terms carefully. By accessing or using this service,
      you agree to be bound by these terms and conditions.
    </p>

    <h4>1. Service Overview</h4>
    <p>
      This section describes the service and its primary functions.
      Replace this content with your specific service description.
    </p>

    <h4>2. User Responsibilities</h4>
    <p>
      As a user of this service, you are responsible for:
    </p>
    <ul>
      <li>Maintaining the confidentiality of your account</li>
      <li>Providing accurate and truthful information</li>
      <li>Complying with all applicable regulations</li>
      <li>Protecting privacy and confidentiality</li>
    </ul>
  </>
);

export const PrivacyTemplate = () => (
  <>
    <h3>Privacy Policy</h3>
    <p>
      This Privacy Policy describes how we collect, use, and handle your information.
    </p>

    <h4>1. Information Collection</h4>
    <p>
      We collect information that you provide directly to us, including:
    </p>
    <ul>
      <li>Account information</li>
      <li>Usage data</li>
      <li>Communication preferences</li>
    </ul>

    <h4>2. Data Usage</h4>
    <p>
      We use collected information to:
    </p>
    <ul>
      <li>Provide and maintain our services</li>
      <li>Improve user experience</li>
      <li>Send important notifications</li>
    </ul>
  </>
);

export const exampleDisclaimers = {
  terms: {
    id: 'terms',
    title: 'Terms & Conditions',
    content: <TermsTemplate />,
  },
  privacy: {
    id: 'privacy',
    title: 'Privacy Policy',
    content: <PrivacyTemplate />,
  },
};
